import { Injectable } from '@angular/core';
import { Http, Response, ResponseContentType } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { AppConfig } from '../app.config';
import { ProgressService } from './progress.service';
import { BaseService } from './base.service';
import { MIHDocumentType } from 'app/viewmodel';

@Injectable()
export class FilesService extends BaseService {
    _baseUrl: string = AppConfig.config.defaultServicePath + 'MIHFile/';

    constructor(
          private http: Http
        , private progressService: ProgressService) {
        super();
    }

    getDocumentTypes(projectID: number) {
        this.progressService.add();
        return this.http.get(this._baseUrl + 'GetDocumentTypes?projectID=' + projectID, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove());
    }

    getSubDocumentTypes(documentType: MIHDocumentType) {
        this.progressService.add();
        return this.http.get(`${this._baseUrl}GetSubDocumentTypes?projectID=${documentType.ProjectID}&documentType=${documentType.DocumentType}&bldgID=${documentType.BldgID}&partyID=${documentType.PartyID}&partyStagingID=${documentType.PartyStagingID}`, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove());
    }

    getUploadDocsByProjectId(projectID: number) {
        this.progressService.add();
        return this.http.get(this._baseUrl + 'GetDocuments?projectID=' + projectID, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove());
    }

    uploadMIHFile(files, uploadDocInfo) {
        this.progressService.add();
        var options = this.addHeader();
        options.headers.delete('Content-Type');
        options.params = uploadDocInfo;
        return this.http.post(this._baseUrl + 'UploadMIHFile', files, options)
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    downloadDocument(documentId: number, documentName: string) { 
        this.progressService.add();
        return this.http.get(this._baseUrl + 'DownloadDocument?documentId=' + documentId + '&documentName=' + documentName, this.blobRequestOptions())
            .map((resp: Response) => resp.blob())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove());
    }

    deleteDocument(documentId: number) {
        this.progressService.add();
        return this.http.post(this._baseUrl + 'DeleteDocument', documentId, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }   

    getCheckListDocumentByProjectId(projectId: number) {
        this.progressService.add();
        return this.http.post(this._baseUrl + 'GetCheckListDocumentByProjectId', projectId, this.blobRequestOptions())
            .map((resp: Response) => resp.blob())
        .catch(this.errorHandler)
        .finally(() => this.progressService.remove())

    }

    getCheckListInfo(projectId: number) {
        this.progressService.add();
        return this.http.post(this._baseUrl + 'GetCheckListInfo', projectId, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())

    }

    /*
    uploadCheckListTemplate(projectId: number) {
        this.progressService.add();
        return this.http.post(this._baseUrl + 'UploadCheckListTemplate', projectId, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }
    */

}
